var finansudd = finansudd || {};

finansudd.toolbar = new function(){

    var self = this;

    this.toggleMenu = function (selector) {

    	var $toolbarTriggers = $('#toolbar ul > li.has-dropdown .dropdown-trigger');

    	$toolbarTriggers.click(function() {
    		var $this = $(this);

    		$('body').addClass('open-overlay');
    		$this.siblings('.toolbar-menu').toggleClass('active');

    		if($this.hasClass("favorites")){
    			var favoritList = localStorage.favorites;
    			finansudd.courselist.loadFavorites(1, favoritList);
    		}
    	});

    	finansudd.overlay.removeActive('.toolbar-menu', 'active');
	};

    this.toggleSearch = function (selector) {
    	var $selector = $(selector),
    		$searchWrapper = $('#search-wrapper');

		$selector.click(function() {

			if(!$searchWrapper.hasClass('mobile-active')) {
				$searchWrapper.addClass('mobile-active');
			} else {
				$searchWrapper.removeClass('mobile-active');
			}

            $('.search-input').focus();
			$('body').addClass('open-overlay');
    	});

    	finansudd.overlay.removeActive('#search-wrapper', 'mobile-active');

	};

    this.animateIcon = function (iconClass, aClass) {

        var activeClass = aClass ? aClass : "active",
            icon = iconClass ? iconClass : null;

        if (icon != null) {

            $(icon).addClass(activeClass);

            setTimeout(function() {
                $(icon).removeClass(activeClass)
            }, 2000);
        }



    };

};
